import styled, { css } from "styled-components/macro";
import { DefaultFont } from "../../../styles/fonts";
import { X as CloseIcon } from "@styled-icons/bootstrap/X";
import { HouseDoor } from "@styled-icons/bootstrap";
import { Button } from "antd";

export const Root = styled.div`
  background: #ffffff;
  padding: 16px;
  border: 1px solid ${(p) => p.theme.colors.borderSecondary};
  border-radius: 8px;
  width: 248px;
  /* height: 100px; */
  position: relative;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0px 4px 6px -2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
`;

export const HostContainer = styled.div`
  display: flex;
  gap: 16px;

  .SkeletonInput {
    flex-grow: 1;
    margin-right: 20px;
    .ant-skeleton-input {
      width: 100%;
      min-width: auto;
    }
  }
`;
export const HostAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 36px;
`;
export const HostNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HostLabel = styled.div`
  ${DefaultFont};
  font-size: 12px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
  color: ${(p) => p.theme.colors.textDimmed};
`;
export const HostName = styled.div`
  ${DefaultFont};
  font-size: 18px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
  color: ${(p) => p.theme.colors.bgDark};
`;
export const Dates = styled.div`
  ${DefaultFont};
  font-size: 12px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
  color: ${(p) => p.theme.colors.textDimmed};

  margin-bottom: 8px;
`;

export const RoomName = styled.div`
  ${DefaultFont};
  font-size: 18px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 16px;
  }
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const RoomLocation = styled.div`
  ${DefaultFont};
  font-size: 14px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const RoomInfo = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  ${DefaultFont};
  font-size: 14px;
  @media ${(props) => props.theme.media.phone} {
    font-size: 14px;
  }
`;
export const RoomPrice = styled.div`
  font-weight: ${(p) => p.theme.font.weightMedium};
  color: ${(p) => p.theme.text.color.orange};
`;
export const RoomSize = styled.div`
  display: flex;
  gap: 5px;
  font-weight: ${(p) => p.theme.font.weightMedium};
`;
export const RoomSizeMeasureUnits = styled.div`
  color: ${(p) => p.theme.text.color.blueDimmed};
`;
export const RoomType = styled.div`
  display: flex;
  align-items: center;
`;
export const RoomPhotosCarouselContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
  position: relative;

  /* height: 100px; */
`;

export const LikeButtonRoot = styled.button`
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.73);
  border: 1px solid white;

  position: absolute;
  top: 8px;
  right: 8px;

  svg {
    position: relative;
    width: 20px;
    height: auto;
    top: 1px;

    path {
      fill: ${(p) => p.theme.colors.text};
    }
  }
`;

export const CloseButton = styled(CloseIcon)`
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  height: 30px;
`;

export const VerifiedBadgeRoot = styled.div`
  position: absolute;
  left: 8px;
  top: 9px;

  ${DefaultFont};
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(250, 252, 255, 0.75);
  border-radius: 4px;
  padding: 4px 8px;

  svg {
    width: 20px;
    height: auto;
  }

  span {
    position: relative;
    top: 1px;
  }
`;

export const PhotoPlaceholder = styled.div`
  height: 154px;
  background: ${(p) => p.theme.colors.softGray};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HouseDoorIcon = styled(HouseDoor)`
  width: 15px;
  margin-right: 5px;
  color: ${(props) => props.theme.colors.textDimmed};
`;

export const RoomStatusBoxRoot = styled(Button) <{ color: string }>`
  border: none !important;

  ${(p) =>
    p.onClick
      ? css`
          cursor: pointer;
        `
      : ""}

  ${(p) =>
    p.color === "default"
      ? css`
          color: ${(p) => p.theme.colors.chatFadedTextColor} !important;
          background: #f3f3f3 !important;
        `
      : ""}

  ${(p) =>
    p.color === "orange"
      ? css`
          color: white !important;
          background: ${(p) => p.theme.colors.primary} !important;
        `
      : ""}

  ${(p) =>
    p.color === "blue"
      ? css`
          color: white !important;
          background: ${(p) => p.theme.colors.text} !important;
        `
      : ""}
`;
